import { useState } from 'react';
import { label as labelCls, input as inputCls, inputError, fieldError } from '../../lib/ui';

// Labelled text input. Passing `type="password"` adds a Show/Hide toggle.
export default function TextField({ id, label, error, hint, className = '', inputClassName = '', ...props }) {
  const [shown, setShown] = useState(false);
  const isPassword = props.type === 'password';
  const type = isPassword && shown ? 'text' : props.type;

  return (
    <div className={className}>
      <label htmlFor={id} className={labelCls}>{label}</label>
      <div className="relative">
        <input
          id={id}
          {...props}
          type={type}
          aria-invalid={error ? true : undefined}
          className={`${inputCls} ${isPassword ? 'pr-16' : ''} ${error ? inputError : ''} ${inputClassName}`}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShown((s) => !s)}
            aria-label={shown ? 'Hide password' : 'Show password'}
            className="absolute inset-y-0 right-3 my-auto h-8 rounded-md px-2 text-sm font-medium text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white"
          >
            {shown ? 'Hide' : 'Show'}
          </button>
        )}
      </div>
      {error && <p className={fieldError}>{error}</p>}
      {!error && hint && <p className="mt-1.5 text-sm text-slate-500 dark:text-slate-400">{hint}</p>}
    </div>
  );
}
